<app-roles-cta
  [hasAccess]="dialogData.hasAccess"
  (dismiss)="onDismiss()"
></app-roles-cta>
